var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyToClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#FF6D34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3402 35.7594H36.2602C37.3206 35.7594 38.1802 34.8998 38.1802 33.8394V23.2794C38.1802 22.219 37.3206 21.3594 36.2602 21.3594H27.6202C26.5598 21.3594 25.7002 22.219 25.7002 23.2794V25.1994",
    stroke: "white",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7252 27.5669L31.9687 25.8104C31.5749 25.4166 31.0408 25.1953 30.4838 25.1953H24.7403C23.6799 25.1953 22.8203 26.0549 22.8203 27.1153V36.7153C22.8203 37.7757 23.6799 38.6353 24.7403 38.6353H32.4203C33.4807 38.6353 34.3403 37.7757 34.3403 36.7153V29.0518C34.3403 28.4949 34.1191 27.9607 33.7252 27.5669Z",
    stroke: "white",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.34 29.5153H31.46C30.6647 29.5153 30.02 28.8706 30.02 28.0753V25.1953",
    stroke: "white",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyToClipboard);
export default __webpack_public_path__ + "static/media/copyToClipboard.0d61db2c77b29e7aee3c048d51201377.svg";
export { ForwardRef as ReactComponent };